import type { Category, Question, QAQuestionParticipants } from '@/types/qa'

export type QuestionAnswerState = {
  categories: Array<Category>
  categoriesPending: boolean
  deleteQuestionPending: boolean
  filters: Array<Filter>
  filtersPaneIsOpen: boolean
  importQuestionsPending: boolean
  markQuestionAsResolvedPending: boolean
  patchQuestionRightsPending: boolean
  questionsBulkRightsPending: boolean
  postAnswerPending: boolean
  postQuestionPending: boolean
  patchQuestionPending: boolean
  question: Question | null
  questionPending: boolean
  questions: {
    questions: Array<Question>
  }
  questionsPending: boolean
  questionParticipants: QAQuestionParticipants
  questionParticipantsPending: boolean
}

export const state: QuestionAnswerState = {
  categories: [],
  categoriesPending: false,
  deleteQuestionPending: false,
  filters: [],
  filtersPaneIsOpen: false,
  importQuestionsPending: false,
  markQuestionAsResolvedPending: false,
  patchQuestionRightsPending: false,
  questionsBulkRightsPending: false,
  postAnswerPending: false,
  postQuestionPending: false,
  patchQuestionPending: false,
  question: null,
  questionPending: false,
  questions: {
    questions: [],
  },
  questionsPending: false,
  questionParticipants: {
    author: null,
    users: [],
    groups: [],
  },
  questionParticipantsPending: false,
}
